module.exports = __webpack_public_path__ + "img/U7.102708ac.png";